<div class="metadata">
  <span class="date">{{
    date | friendlyDate: false:2:0:dateFormat:dateTranslationKeys
  }}</span>
  <span class="dot-separator"></span>
  <span class="time">{{ date | friendlyDate: true:0:0:timeFormat }}</span>
</div>

<div class="username">{{ name }}</div>

<div class="message">{{ message }}</div>
